import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const [isVisible, setIsVisible] = useState(false);

  // Scroll to top when pathname changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // Toggle visibility of the buttons when scrolling
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  // Scroll functions
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const scrollToBottom = () => {
    window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
  };

  return (
    <>
      {isVisible && (
        <div
          style={{
            position: "fixed",
            bottom: "30px",
            right: "30px",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          {/* Scroll to Top Button */}
          <div
            onClick={scrollToTop}
            style={buttonStyle}
          >
            <span style={arrowStyle}>↑</span>
          </div>

          {/* Scroll to Bottom Button */}
          <div
            onClick={scrollToBottom}
            style={buttonStyle}
          >
            <span style={arrowStyle}>↓</span>
          </div>
        </div>
      )}
    </>
  );
}

// Common Button Styles
const buttonStyle = {
  width: "30px",
  height: "30px",
  backgroundColor: "#397bfd",
  color: "#fff",
  borderRadius: "50%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  cursor: "pointer",
  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
};

// Arrow Icon Styles
const arrowStyle = {
  fontSize: "15px",
  fontWeight: "bold",
};
